import PropTypes from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';
import Tooltip from '@/components/core/Tooltip';

const GroupToggleField = ({ name, value, readOnly, onChange, paramSchema }) => {
  const { control } = useFormContext();
  const { label, tooltip, source } = paramSchema;

  return (
    <div className="flex gap-2 items-center self-end">
      <Controller
        control={control}
        name={name}
        defaultValue={value}
        render={({ field: { value: fieldValue, onChange: fieldOnChange } }) => (
          <input
            type="checkbox"
            disabled={readOnly}
            readOnly={readOnly}
            name={name}
            className="toggle toggle-success toggle-xs"
            onChange={e => {
              const newValue = e.target.checked;
              fieldOnChange(newValue);

              if (onChange) {
                onChange(e);
              }
            }}
            checked={fieldValue === true}
          />
        )}
      />
      {label && (
        <div className="flex items-center gap-1">
          <label htmlFor={name} className="block truncate text-xs">
            {label}
          </label>
          {tooltip && <Tooltip label={label} text={tooltip} source={source} />}
        </div>
      )}
    </div>
  );
};

GroupToggleField.propTypes = {
  name: PropTypes.string.isRequired,
  paramSchema: PropTypes.object,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  value: PropTypes.bool,
};

export default GroupToggleField;
